import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { DialogContent } from "../errors/DialogContent";
import { ButtonDelete } from "../generic/common/ButtonDelete";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { TextLoca } from "../generic/text/TextLoca";
import { actionLandingPageLogoutConfirmation } from "../landing-page/actionLandingPage";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
var DialogLogoutConfirmationDOM = function (_a) {
    var onClose = _a.onClose, onConfirm = _a.onConfirm;
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.tooltip_hud_logout_web, className: IdStyles.ModalBackgroundInfo, onClose: onClose },
        React.createElement("div", { className: "flex flex--stacked flex--guts h100" },
            React.createElement(DialogContent, { messageLocaId: IdLoca.logout_confirmation_web }),
            React.createElement("div", { className: "button-ribbon" },
                React.createElement(ButtonDelete, { onClick: onClose },
                    React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.cancel })),
                React.createElement(ButtonPrimary, { onClick: onConfirm },
                    React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.confirm }))))));
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.LogoutConfirmation)); },
    onConfirm: function () { return dispatch(actionLandingPageLogoutConfirmation()); },
}); };
export var DialogLogoutConfirmation = connect(undefined, mapDispatch)(DialogLogoutConfirmationDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/logout-dialog/DialogLogoutConfirmation.tsx
// module id = 2845
// module chunks = 3